export default "__VITE_ASSET__CTWIZfOj__"